import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { apiEndpointURL } from '@app/core/constants/endpoints-url';
import { Utilities } from '@app/core/utils/utilities';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CampusService {
  private util = inject(Utilities);
  private httpClient = inject(HttpClient);

  getCampusDetails(institutionId: any, pageNo: number, sortBy?: any, sortOrder?: any, appliedFilter?: any, pageName?: string, campusAvailabilityStatus?: any, pageSize?: number, from?: string): Observable<any> {
    let params = new HttpParams().set('pageNumber', pageNo).set('pageSize', pageSize ?? this.util.recordsPerPage());
    if (sortBy)
      params = params.set('sortBy', sortBy);
    if (sortOrder === 'desc')
      params = params.set('sortOrder', sortOrder);
    if (pageName)
      params = params.set('pageName', pageName)
    if(campusAvailabilityStatus)
      params = params.set('campusStatus', campusAvailabilityStatus);
    if (appliedFilter)
      Object.keys(appliedFilter).forEach((data) => {
        params = params.set(data, appliedFilter[data])
      });
    if (from === 'resolver') params = params.set('resolver', true);
    const campusUrl = apiEndpointURL.campusDataEndpoint + institutionId + '/campuses';
    return this.httpClient.get(campusUrl, { params });
  }

  archiveOrUnarchiveCampus(institutionId: any, campusId: any, status: string): Observable<any> {
    const url = [apiEndpointURL.getInstitutionEndpoint, institutionId, "campuses", campusId, status].join('/');
    let bodyContent: any = null;
    if (this.util.getStoredUserDetails().userId)
      bodyContent = { updatedBy: Number(this.util.getStoredUserDetails().userId) };
    return this.httpClient.patch(url, bodyContent);
  }

  getJSON(): Observable<any> {
    const params = new HttpParams().set('headerNotRequired', true);
    return this.httpClient.get(apiEndpointURL.campusFieldJson, { params });
  }

  fetchCourseTypeDetails() {
    return this.httpClient.get(apiEndpointURL.campusCourseTypeEndpoint);
  }

  saveCampusDetails(campusData: any, institutionId: any, campusId: string) {
    const url = [apiEndpointURL.getInstitutionEndpoint, institutionId, "campuses"].join('/');
    if (campusId)
      return this.httpClient.put(url + '/' + campusId, campusData)
    else
      return this.httpClient.post(url, campusData)
  }

  getViewCampusData(institutionId: any, campusId: any, from?: string): Observable<any> {
    let params = new HttpParams();
    if (from === 'resolver') params = params.set('resolver', 'true');
    const url = [apiEndpointURL.getInstitutionEndpoint, institutionId, "campuses", campusId].join('/');
    return this.httpClient.get(url, { params });
  }

  getAjaxReferencData(institutionId: any, filterBy: any, campusAvailabilityStatus?: string) {
    let params = new HttpParams().set("filterBy", filterBy);
    if(campusAvailabilityStatus)
      params = params.set('campusStatus', campusAvailabilityStatus)
    const url = [apiEndpointURL.getInstitutionEndpoint, institutionId, "campuses/filterData"].join('/');
    return this.httpClient.get(url, { params });
  }
}
